import React from 'react';
import MainWindow from '../components/MainWindow';
import ThemeConfigDrawer from '../components/ThemeConfigDrawer';
import ErrorBoundary from '../components/ErrorBoundary';
import { styled } from '@mui/system';
import Header from "../components/Header"
import { useAppSelector } from "../app/hooks"
import { editor } from "../slices/auth-slice"
import { useNavigate } from 'react-router-dom';
import { affiliateDataId } from '../slices/affiliateTheme';

const AppRoot = styled("div")({
    display: "flex",
    height: "100vh",
});

const HeaderNavAndMain = styled("div")({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
});

const NavAndMain = styled("div")({
    flex: 1,
    display: "flex",
    minHeight: 0,
});

const Main = styled("main")({
    minWidth: 0,
    minHeight: 0,
    flex: 1,
    display: "flex",
    flexDirection: "column",
});

const BlankMessage = styled("div")({
    height: "100vh",
    fontSize: "16px",
    fontWeight: "400",
})

export default function Editor() {
    const affiliateId = useAppSelector(affiliateDataId);

    // if (editorStatus) navigate('/publisher-dashboard', { replace: true });
    // const classes = useStyles;

    return (
        <AppRoot>
            <ErrorBoundary>
                <HeaderNavAndMain className="header">
                    <Header />
                    <NavAndMain>
                        <Main>
                            {
                                affiliateId ? <MainWindow /> : <BlankMessage className=' d-flex justify-content-center align-items-center ' >Please Select Affiliate... </BlankMessage>
                            }
                        </Main>
                    </NavAndMain>
                </HeaderNavAndMain>
                {
                    affiliateId && <ThemeConfigDrawer />
                }
            </ErrorBoundary>
        </AppRoot>
    )
}
